import * as Yup from "yup";
import {yupRequiredString} from "../yup/Validators";

export const CreateHomeCommentSchema = Yup.object().shape({
  date: yupRequiredString,
  content: yupRequiredString,
})
